// extracted by mini-css-extract-plugin
export default {"container":"details_container__J4reD","id":"details_id__op1t6","image":"details_image__iQ2HX"};